<!-- <span class="head-line-5">DEBUG: ({{ currentRouteInfo.translationLabel }})</span> | -->
<ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
  <span class="head-line-5 breadcrumb-link" [routerLink]="breadcrumb.link">{{
    breadcrumb.translationPath | translate
  }}</span>
  <span *ngIf="i < breadcrumbs.length - 1" class="material-symbols-outlined"> chevron_right </span>
</ng-container>
